export default __webpack_public_path__ + "static/media/punctual.e0443520.svg";